/* import component */
import PortfolioCard from './portfolio-card';

const PortfolioItem = () => {
    return (
        <>      
            <PortfolioCard/>
        </> 
    );
}
 
export default PortfolioItem;